
export class CompletePersonellDataDto {
    id = 0;
    svNumber = "";
    birthDate = "";
    birthPlace = "";
    maritalStatus = "";
}
